import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../ActionTypes";
import {
  saveServiceSuccess,
  saveServiceFailure,
  saveCampusTimeSuccess,
  saveCampusTimeFailure,
  saveServiceGallerySuccess,
  saveServiceGalleryFailure,
  deleteServiceSuccess,
  deleteServiceFailure,
  updateServiceSuccess,
  updateServiceFailure,
  updateCampusTimeSuccess,
  updateCampusTimeFailure,
  updateServiceGallerySuccess,
  updateServiceGalleryFailure,
  deleteServiceGallerySuccess,
  deleteServiceGalleryFailure,
  deleteCampusTimeSuccess,
  deleteCampusTimeFailure
} from "./servicesActions";
import { saveService ,saveCampusAndTime,saveServiceGallery,deleteService,  updateService,
    updateCampusAndTime,
    updateServiceGallery,deleteServiceGallery,deleteCampusAndTime} from "./services";

// 🔹 Save Service Saga
function* saveServiceSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const data = yield call(saveService, apiPayloadRequest);

    if (data?.type === 1) {
      const result = { ...apiPayloadRequest, ...data.data, serviceObjId: data.serviceObjId };
      yield put(saveServiceSuccess(result));
      action.callback?.({ type: 1, data: result });
    } else {
      yield put(saveServiceFailure(data?.error || "Save failed"));
      action.callback?.({ type: 0, error: data?.error });
    }
  } catch (error) {
    yield put(saveServiceFailure(error.message));
    action.callback?.({ type: 0, error: error.message });
  }
}
function* saveCampusTimeSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const data = yield call(saveCampusAndTime, apiPayloadRequest);

    if (data?.type === 1) {
      const result = {
        ...apiPayloadRequest,
        ...data.data,
        serviceObjId: data.data?.serviceObjId, // FIXED
      };

      yield put(saveCampusTimeSuccess(result));
      action.callback?.({ type: 1, data: result });
    } else {
      yield put(saveCampusTimeFailure(data?.error || "Save failed"));
      action.callback?.({ type: 0, error: data?.error });
    }
  } catch (error) {
    yield put(saveCampusTimeFailure(error.message));
    action.callback?.({ type: 0, error: error.message });
  }
}


function* saveServiceGallerySaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const data = yield call(saveServiceGallery, apiPayloadRequest);

    if (data?.type === 1) {
      const result = { ...apiPayloadRequest, ...data.data, serviceObjId: data.serviceObjId };
      yield put(saveServiceGallerySuccess(result));

      setTimeout(() => {
        action.callback?.({ type: 1, data: result });
      }, 0);

    } else {
      yield put(saveServiceGalleryFailure(data?.error || "Save failed"));

      setTimeout(() => {
        action.callback?.({ type: 0, error: data?.error });
      }, 0);
    }
  } catch (error) {
    yield put(saveServiceGalleryFailure(error.message));

    setTimeout(() => {
      action.callback?.({ type: 0, error: error.message });
    }, 0);
  }
}

  function* deleteServiceSaga(action) {
    try {
      const { apiPayloadRequest } = action.payload;
      const data = yield call(deleteService, apiPayloadRequest);

      if (data?.type === 1) {
        yield put(deleteServiceSuccess(apiPayloadRequest));
        action.callback?.({ type: 1, data });
      } else {
        yield put(deleteServiceFailure(data?.error || "Delete failed"));
        action.callback?.({ type: 0, error: data?.error });
      }
    } catch (error) {
      yield put(deleteServiceFailure(error.message));
      action.callback?.({ type: 0, error: error.message });
    }
  }
  function* updateServiceSaga(action) {
    try {
      const { apiPayloadRequest } = action.payload;
      const data = yield call(updateService, apiPayloadRequest);

      if (data?.type === 1) {
        const result = { ...apiPayloadRequest, ...data.data };
        yield put(updateServiceSuccess(result));
        action.callback?.({ type: 1, data: result });
      } else {
        yield put(updateServiceFailure(data?.error || "Update failed"));
        action.callback?.({ type: 0, error: data?.error });
      }
    } catch (error) {
      yield put(updateServiceFailure(error.message));
      action.callback?.({ type: 0, error: error.message });
    }
  }

  // 🔹 Update Campus & Time
  function* updateCampusTimeSaga(action) {
    try {
      const { apiPayloadRequest } = action.payload;
      const data = yield call(updateCampusAndTime, apiPayloadRequest);

      if (data?.type === 1) {
        const result = { ...apiPayloadRequest, ...data.data };
        yield put(updateCampusTimeSuccess(result));

        setTimeout(() => {
          action.callback?.({ type: 1, data: result });
        }, 0);

      } else {
        yield put(updateCampusTimeFailure(data?.error || "Update failed"));

        setTimeout(() => {
          action.callback?.({ type: 0, error: data?.error });
        }, 0);
      }
    } catch (error) {
      yield put(updateCampusTimeFailure(error.message));

      setTimeout(() => {
        action.callback?.({ type: 0, error: error.message });
      }, 0);
    }
  }


  // 🔹 Update Service Gallery
  function* updateServiceGallerySaga(action) {
    try {
      const { apiPayloadRequest } = action.payload;
      const data = yield call(updateServiceGallery, apiPayloadRequest);

      if (data?.type === 1) {
        const result = { ...apiPayloadRequest, ...data.data };
        yield put(updateServiceGallerySuccess(result));
        action.callback?.({ type: 1, data: result });
      } else {
        yield put(updateServiceGalleryFailure(data?.error || "Update failed"));
        action.callback?.({ type: 0, error: data?.error });
      }
    } catch (error) {
      yield put(updateServiceGalleryFailure(error.message));
      action.callback?.({ type: 0, error: error.message });
    }
  }
  function* deleteServiceGallerySaga(action) {
    try {
      // Extract the actual IDs object
      const { apiPayloadRequest } = action.payload;

      // Flatten and pass all required keys to API
      const payloadForAPI = {
        serviceGalleryObjId: apiPayloadRequest?.serviceGalleryObjId,
        serviceObjId: apiPayloadRequest?.serviceObjId,
        _id: apiPayloadRequest?._id,
      };

      const data = yield call(deleteServiceGallery, payloadForAPI);

      if (data?.type === 1) {
        yield put(deleteServiceGallerySuccess(apiPayloadRequest)); // reducer uses full object
        action.callback?.({ type: 1, data: apiPayloadRequest });
      } else {
                yield put(deleteServiceGalleryFailure(data?.error || "Delete failed"));
        action.callback?.({ type: 0, error: data?.error });
      }
    } catch (error) {
            yield put(deleteServiceGalleryFailure(error.message));
      action.callback?.({ type: 0, error: error.message });
    }
  }

  function* deleteCampusTimeSaga(action) {
    try {
      const { apiPayloadRequest } = action.payload;

      const payloadForAPI = {
        _id: apiPayloadRequest?._id,
        serviceObjId: apiPayloadRequest?.serviceObjId,
        campusandtimeObjId: apiPayloadRequest?.campusandtimeObjId,
      };

      const data = yield call(deleteCampusAndTime, payloadForAPI);

      if (data?.type === 1) {
        yield put(deleteCampusTimeSuccess(apiPayloadRequest));
        action.callback?.({ type: 1, data: apiPayloadRequest });
      } else {
        yield put(deleteCampusTimeFailure(data?.error || "Delete failed"));
        action.callback?.({ type: 0, error: data?.error });
      }
    } catch (error) {
      yield put(deleteCampusTimeFailure(error.message));
      action.callback?.({ type: 0, error: error.message });
    }
  }



// 🔹 Watcher
export default function* servicesWatcherSaga() {
  yield takeLatest(actionTypes.SAVE_SERVICE_REQUEST, saveServiceSaga);
  yield takeLatest(actionTypes.SAVE_CAMPUS_TIME_REQUEST, saveCampusTimeSaga);
  yield takeLatest(actionTypes.SAVE_SERVICE_GALLERY_REQUEST, saveServiceGallerySaga);
  yield takeLatest(actionTypes.DELETE_SERVICE_REQUEST, deleteServiceSaga);
  yield takeLatest(actionTypes.UPDATE_SERVICE_REQUEST, updateServiceSaga);
  yield takeLatest(actionTypes.UPDATE_CAMPUS_TIME_REQUEST, updateCampusTimeSaga);
  yield takeLatest(actionTypes.UPDATE_SERVICE_GALLERY_REQUEST, updateServiceGallerySaga);
  yield takeLatest(
    actionTypes.DELETE_SERVICE_GALLERY_REQUEST,
    deleteServiceGallerySaga
  );
  yield takeLatest(
    actionTypes.DELETE_CAMPUS_TIME_REQUEST,
    deleteCampusTimeSaga
  );



}
